import SearchBarSearchInput from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInput';
import CustomIcon from '@components/utils/CustomIcon';
import { PlaneLanding } from '@assets/icons';
import { SearchBarInputError } from '@components/views/flight/types';
import { useDebounceValue } from '@hooks/hooks';
import { useAirportSearchGet } from '@components/views/flight/hooks/flight.query';
import { AirportSearchViewModel } from '@api/index';
import {
  AirportsContainer,
  AirportWrapper,
} from '@components/views/flight/listing/SearchBar/AirportSearch/SearchBarAirportSearchStyle';
import { useDevice } from '@contexts/device';
import ResponsiveSearchDrawerItem from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import { SearchInput } from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInputStyle';

export default function ArrivalAirportSearch({
  arrivalAirportSearchText,
  arrivalAirportSelectError = false,
}: {
  arrivalAirport?: AirportSearchViewModel;
  arrivalAirportError?: SearchBarInputError | boolean;
  arrivalAirportSearchText?: string;
  arrivalAirportSelectError?: boolean;
}) {
  const debouncedarrivalSearchText = useDebounceValue(arrivalAirportSearchText);
  const { isDesktop } = useDevice();
  const { isError: isarrivalDataError } = useAirportSearchGet({
    airportName: debouncedarrivalSearchText,
    select: (airports) => airports,
  });

  return isDesktop ? (
    <AirportsContainer>
      <AirportWrapper>
        <SearchBarSearchInput
          isFlight={true}
          label='Nereye Gideceksiniz?'
          inputProps={{
            value: arrivalAirportSearchText,
            placeholder: 'Havalimanı veya Şehir',
          }}
          error={arrivalAirportSelectError}
          searchTextError={isarrivalDataError}
          leftIcon={() => (
            <CustomIcon
              fontSize={28}
              paletteColor='coral'
              icon={PlaneLanding}
            />
          )}
          rightIcon={() => null}
          SearchResultListComponent={() => null}
          disabled={true}
        />
      </AirportWrapper>
    </AirportsContainer>
  ) : (
    <ResponsiveSearchDrawerItem
      icon={PlaneLanding}
      title='Nereye Gideceksiniz?'
      placeholder='Havalimanı veya şehir'
      subTitle={
        <SearchInput
          autoComplete='off'
          aria-label='search-input'
          placeholder='Havalimanı veya şehir'
          value={arrivalAirportSearchText}
          disabled={true}
        />
      }
    />
  );
}
